import textServices from 'services/text-services'
import F1Picture from './F1Picture'

// "Pit Stops ¿Qué son?" (Figma 5595:12089): F1 car footage with a dark glass
// card holding the explainer copy (left-aligned card from tablet up).
const WhatAreSection = () => {
  return (
    <section className="pitstops__what">
      <F1Picture name="que_son-background" className="pitstops__what-bg" />
      <div className="pitstops__what-card">
        <h2 className="pitstops__what-title">
          {textServices.findByText('pitstops/what/titleTop', 'Pit Stops')}
          <br />
          {textServices.findByText('pitstops/what/titleBottom', '¿Qué son?')}
        </h2>
        <p className="pitstops__what-text">
          {textServices.findByText(
            'pitstops/what/text',
            'Son retos semanales que te llevan cada vez más cerca de la F1. Completa los tres primeros para desbloquear tu participación por un pase doble al Paddock en el Pit Stop Final.'
          )}
        </p>
      </div>
    </section>
  )
}

export default WhatAreSection
